<template>
  <div class="cont">
    <template v-if="item.CustomerId">
      <v-card :to="{ name: 'ViewCustomer', params: { customerId: item.CustomerId } }" color="transparent" flat
        class="line px-2 py-1">
        <v-icon class="mr-2" size="15">$customer</v-icon>
        {{ item.Customer ? item.Customer.Name : '' }}
      </v-card>
    </template>
    <template v-if="item.JobId">
      <v-card :to="{ name: 'ViewJob', params: { filter: 'my', jobId: item.JobId } }" color="transparent" flat
        class="line px-2 py-1">
        <v-icon class="mr-2" size="18">mdi-chevron-right</v-icon>
        <v-icon class="mr-2" size="15">$job</v-icon>
        {{ item.Job ? item.Job.OrderId : '' }}
      </v-card>
    </template>
    <template v-if="item.MachineId">
      <v-card :to="{ name: 'ViewMachine', params: { machineId: item.MachineId } }" color="transparent" flat
        class="line px-2 py-1">
        <v-icon class="mr-2" size="18">mdi-chevron-right</v-icon>
        <v-icon class="mr-2" size="15">$machine</v-icon>
        {{ item.Machine ? item.Machine.DisplayName : '' }}
      </v-card>
    </template>
  </div>
</template>


<script>
export default {
  name: "AdminLeadsPage",
  props: {
    item: Object,
  },
  components: {
  },

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped>
.cont {
  //border: dashed 1px green;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}

.line {
  //border: dashed 1px red;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.line:hover {
  text-decoration: underline;
  background-color: rgba(0, 0, 0, 0.015) !important;
}

.note-line {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>